import React from 'react';
import Helmet from 'react-helmet';

export default function Template({ data , transition }) {
  const {markdownRemark: post} = data;
  return (
    <div style={transition && transition.style} style={{
      margin: '0 auto',
      maxWidth: 600,
      padding: '0px 1.0875rem 1.45rem',
      paddingTop: 0,
    }}>
      <h1 className="post_head">{post.frontmatter.title}</h1>
      <h4 className="post_date">{post.frontmatter.date}</h4>
      <div dangerouslySetInnerHTML={{__html: post.html}} 
      />
    </div>
  )
}

export const postQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        title
        date
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/post.js